/**
 * WordPress dependencies
 */
import { useContext } from '@wordpress/element';
import { useObservableValue } from '@wordpress/compose';

/**
 * Internal dependencies
 */
import SlotFillContext from '../context';
export default function useSlot(name) {
  const registry = useContext(SlotFillContext);
  const slot = useObservableValue(registry.slots, name);
  let ref;
  if (slot && slot.type === 'portal') {
    ref = slot.ref;
  }
  return {
    ref
  };
}